import React, { useRef, useState } from 'react';
import { Stack, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';

import { AddButton } from '../../components/common/button/CustomButtons';
import ChildHeader from '../../components/ui/ChildHeader';
import { SearchFilterContainer } from '../../assets/styles/layout/searchFilter.styled';
import FilterBy from '../../components/common/FilterBy';
import { SearchBar } from '../../components/common/SearchBar';
import {
  CustomPagination,
  // StatePagination,
  TableCustom,
} from '../../components/common';
import useDebounce from '../../hooks/useDebounce';
import {
  EditIconButton,
  DeleteIconButton,
  ViewIconButton,
  // AddIconButton,
  CustomIconButton,
  CardIconButton,
} from '../../components/common/button/CustomIconButton';
import Create from './Create';
import ModalCustom from '../../components/common/Modal';
import { useQuery } from '../../hooks/UseQuery';
import useConfirm from '../../components/common/useConfirm';

import { IData } from './Interface';
import { Loader } from '../../components/common/Loader';
// import ViewFile from './ViewFile';
// import CustomUploadButton from '../../components/common/button/CustomUploadButton';
import { useNavigate } from 'react-router-dom';
import SparePartList from './component/list/SparePartList';
import { Add } from '@mui/icons-material';
import ViewSparePartList from './component/list/ViewSparePartList';

const tableHeaderObj = [
  [
    { text: '#', rowspan: 1, colspan: 1 },
    { text: 'Machine Name', rowspan: 1, colspan: 1 },
    { text: 'Make', rowspan: 1, colspan: 1 },
    { text: 'Machine No.', rowspan: 1, colspan: 1 },
    { text: 'Department', rowspan: 1, colspan: 1 },
    { text: 'Capaciity', rowspan: 1, colspan: 1 },
    { text: 'Plant Location', rowspan: 1, colspan: 1 },
    { text: 'Remarks', rowspan: 1, colspan: 1 },
    { text: 'Last Maintenance Done Date', rowspan: 1, colspan: 1 },
    { text: 'Maintenance Due Date', rowspan: 1, colspan: 1 },
    { text: 'Spare Parts Action ', rowspan: 1, colspan: 1 },
    { text: 'Machin History Card', rowspan: 1, colspan: 1 },
    { text: 'Action', rowspan: 1, colspan: 1 },
  ],
];

const filterOptions = [{ value: 'createdAt', name: 'Most Recent First' }];

const List = () => {
  const [data, setData] = useState<IData[]>([]);
  const [isModal, setIsModal] = useState<boolean>(false);
  const [render, setRender] = useState(false);
  const [machineId, setMachineId] = useState<string | null>(null);
  const [perPage, setPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const search = useQuery('search');
  const filter = useQuery('filter');
  const page = useQuery('page') || 1;
  // const [isOpenPopup, setIsOpenPopup] = useState(false);
  // const idRef = useRef('');
  const navigate = useNavigate();
  const [isModalForAddSpare, setisModalForAddSpare] = useState(false);
  const moduleIdref = useRef<any>(null);
  const [sparePartIds, setSparePartIds] = useState<string[]>([]);
  const [isModalForViewSpare, setisModalForViewSpare] = useState(false);
  const [DialogDelete, confirmDelete] = useConfirm(
    'DELETE ',
    'Are you sure you want to delete this?',
  );
  const fetchData = async () => {
    const res = await axios
      .get(
        `/api/machineRoutes?page=${page}&sortBy=${filter}&search=${search}&perPage=${perPage}`,
      )
      .catch((err) => {
        console.log(err);
      });
    setData(res?.data?.results);
    setPerPage(res?.data?.perPage);
    setTotalPages(res?.data?.pages);
  };

  const deleteCustomer = async (id: string) => {
    const ans = await confirmDelete();
    if (!ans) return;
    await axios
      .delete(`/api/machineRoutes/${id}`)
      .then((res) => {
        alert('Document deleted successfully');
        setRender((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  useDebounce(fetchData, 500, [page, search, render, isModal]);
  // const uploadFile = async (e: any, id: string) => {
  //   if (!window.confirm('Are you sure you want upload this Files')) return;
  //   const files = e.target.files;
  //   if (!files) return;
  //   let formData = new FormData();
  //   for (const key of Object.keys(files)) {
  //     formData.append('files', files[key]);
  //   }
  //   setIsLoading(true);
  //   axios
  //     .patch(`/api/machineRoutes/uploadFile/${id}`, formData)
  //     .then((res) => {
  //       if (res.data) {
  //         alert('document upload successly');
  //         setIsLoading(false);
  //         setRender((prev) => !prev);
  //       }
  //     })
  //     .catch((err) => {
  //       setIsLoading(false);
  //       console.log(err);
  //     });
  // };

  const handleUpdateSparePart = (id: string) => {
    const sparePartIndex = sparePartIds.indexOf(id); // checking spare part id exists or not , if not exist then push if not then there is only one option that is to remove id
    if (sparePartIndex === -1) {
      sparePartIds.push(id);
    } else {
      sparePartIds.splice(sparePartIndex, 1);
    }
    if (moduleIdref && Array.isArray(sparePartIds)) {
      axios
        .patch(
          `/api/machineRoutes/sparePartIds/${moduleIdref.current}`,
          sparePartIds,
        )
        .then((res) => {
          if (res.data) {
            alert('updated successfull');
            setRender((prev) => !prev);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <>
      <ChildHeader text="MACHINE LIST">
        <AddButton onClick={() => setIsModal(true)} label="New Machine" />
      </ChildHeader>
      <SearchFilterContainer filter={true}>
        <SearchBar label="Search" />
        <FilterBy options={filterOptions} />
      </SearchFilterContainer>
      <Loader loader={isLoading} />
      <TableCustom tableHeaderObj={tableHeaderObj}>
        <TableBody>
          {data &&
            data.map((item: IData, index: number) => (
              <React.Fragment key={item._id}>
                <TableRow
                // style={{
                //   background: item.type === 'CRITICAL' ? 'yellow' : undefined,
                // }}
                >
                  <TableCell align="center">
                    {perPage * (+page - 1) + index + 1}
                  </TableCell>
                  <TableCell align="center">{item?.machine_name}</TableCell>
                  {/* <TableCell align="center">{item?.model}</TableCell> */}
                  <TableCell align="center">{item?.make}</TableCell>
                  <TableCell align="center">{item?.machine_no}</TableCell>
                  <TableCell align="center">
                    {item?.department_id &&
                      typeof item?.department_id !== 'string' &&
                      item.department_id.department_name}
                  </TableCell>
                  {/* <TableCell align="center">{item?.year_of_built}</TableCell> */}
                  <TableCell align="center">{item?.range_capacity}</TableCell>
                  <TableCell align="center">{item?.plant_location}</TableCell>
                  <TableCell align="center">{item?.remarks}</TableCell>
                  {/* <TableCell align="center">{item?.area}</TableCell> */}
                  {/* <TableCell align="center">{item?.power_load}</TableCell> */}
                  {/* <TableCell align="center">{item?.numatic_load}</TableCell> */}
                  {/* <TableCell align="center">{item?.type}</TableCell> */}
                  {/* <TableCell>
                    <Stack
                      direction={'row'}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <CustomUploadButton
                        id="upload-vendor-documents"
                        accept="image/png,image/jpeg,image/jpg,application/pdf"
                        multiple={true}
                        onChange={(e) => {
                          uploadFile(e, item?._id || '');
                        }}
                      />
                      {item.files?.length > 0 && (
                        <>
                          <ViewIconButton
                            tooltipTitle="view"
                            sx={{ marginLeft: '1.5rem' }}
                            onClick={() => {
                              idRef.current = item._id || '';
                              setIsOpenPopup(true);
                            }}
                          />
                        </>
                      )}
                    </Stack>
                  </TableCell> */}
                  <TableCell align="center">
                    {item?.last_maintenance_date}
                  </TableCell>
                  <TableCell align="center">
                    {item?.maintenance_due_date}
                  </TableCell>
                  <TableCell align="center">
                    <Stack direction="row" sx={{ justifyContent: 'center' }}>
                      <CustomIconButton
                        tooltipTitle="add spare parts"
                        onClick={() => {
                          moduleIdref.current = item._id;
                          setSparePartIds(item.spare_part_ids || []);
                          setisModalForAddSpare(true);
                        }}
                      >
                        <Add />
                      </CustomIconButton>
                      <ViewIconButton
                        tooltipTitle="view spare parts"
                        onClick={() => {
                          moduleIdref.current = item._id;
                          setisModalForViewSpare(true);
                        }}
                      />
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Stack direction="row" sx={{ justifyContent: 'center' }}>
                      <CardIconButton
                        tooltipTitle="Machine History"
                        onClick={() => {
                          navigate(`/common/machineHistory/${item._id}`);
                        }}
                      />
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Stack direction="row" sx={{ justifyContent: 'center' }}>
                      <EditIconButton
                        tooltipTitle="EDIT"
                        onClick={() => {
                          setMachineId(item?._id || '');
                          setIsModal(true);
                        }}
                      />

                      <DeleteIconButton
                        tooltipTitle="DELETE"
                        onClick={() => {
                          deleteCustomer(item?._id || '');
                        }}
                      />
                    </Stack>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
        </TableBody>
      </TableCustom>
      <CustomPagination totalPage={totalPages} />
      <ModalCustom
        openModal={isModal}
        closeModal={() => {
          setMachineId(null);
          setIsModal(false);
        }}
        title="CREATE NEW MACHINE"
      >
        <Create id={machineId} setIsModal={setIsModal} />
      </ModalCustom>
      {/* <ModalCustom
        title="FILE LIST"
        openModal={isOpenPopup}
        closeModal={() => {
          setIsOpenPopup(false);
        }}
      >
        <ViewFile id={idRef.current} />
      </ModalCustom> */}
      <ModalCustom
        title="CRITICAL SPARE PART LIST"
        openModal={isModalForAddSpare}
        closeModal={() => {
          setisModalForAddSpare(false);
        }}
      >
        <SparePartList
          type="choose"
          {...{ handleUpdateSparePart, sparePartIds }}
        />
      </ModalCustom>
      <ModalCustom
        title="CRITICAL SPARE PART LIST"
        openModal={isModalForViewSpare}
        closeModal={() => {
          setisModalForViewSpare(false);
        }}
      >
        <ViewSparePartList
          moduleId={moduleIdref.current}
          // closeModal={setisModalForViewSpare}
        />
      </ModalCustom>
      <DialogDelete isSubmitContent={false} />
    </>
  );
};

export default List;
